import { 
  getEventsByUserRepository, 
  createEventRepository 
} from "../Infrastructure/Events.repository";

export async function getEventsByUserLogic(id) {
  return getEventsByUserRepository(id);
}

export async function createEventLogic(eventData) {
  return createEventRepository(eventData);
}